webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('div', {
    staticClass: "counter-parent"
  }, [_c('span', [_vm._v(_vm._s(_vm.minutes) + ":" + _vm._s(_vm.seconds))])])]), _vm._v(" "), _c('div', {
    staticClass: "canvas-container"
  }, [(_vm.finishedGame) ? _c('div', {
    staticClass: "win-lose-style you-win"
  }, [_vm._v("You Win")]) : _vm._e(), _vm._v(" "), (_vm.timeLeft === 0 && !_vm.finishedGame) ? _c('div', {
    staticClass: "win-lose-style you-lose"
  }, [_vm._v("You Lose")]) : _vm._e(), _vm._v(" "), _c('canvas', {
    ref: "canvas",
    attrs: {
      "width": _vm.canvasWidth,
      "height": _vm.canvasHeight,
      "disabled": ""
    },
    on: {
      "mousedown": _vm.mousedown,
      "mouseup": _vm.mouseup,
      "mousemove": _vm.mousemove
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var Component = __webpack_require__(106)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(107),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Point = function () {
  function Point(x, y) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Point);

    this.x = x;
    this.y = y;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Point, [{
    key: "compare",
    value: function compare(p) {
      if (this.y === p.y) {
        return this.x - p.x;
      } else {
        return this.y - p.y;
      }
    }
  }]);

  return Point;
}();

/* harmony default export */ __webpack_exports__["a"] = (Point);

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Point_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cdt2d__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cdt2d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_cdt2d__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var apiData;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.canvas = _this.$refs.canvas;
              _this.context = _this.canvas.getContext('2d');
              window.addEventListener('load', _this.windowEvent);
              _this.startTimer();
              _context.next = 6;
              return fetch('https://userdb101-23914-default-rtdb.europe-west1.firebasedatabase.app/data.json').then(function (response) {
                return response.json();
              }).then(function (json) {
                var apiFetchResult = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(json);
                return apiFetchResult[0][1];
              }).catch(function (err) {
                return console.log(err);
              });

            case 6:
              apiData = _context.sent;

              _this.pointsCount = apiData.pointsCount;
              _this.timeLeft = apiData.time;
              _this.restart();

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      canvas: {},
      context: {},
      canvasHeight: 500,
      canvasWidth: 900,
      overPoint: null,
      dragMode: false,
      finishedGame: false,
      connectedWithOverPoint: null,
      pointSize: 8,
      pointsCount: null,
      intersectedCount: 0,
      strokeStyle: 'darkgrey',
      fillStyle: '#fff',
      lines: [],
      points: [],
      edges: null,
      timeLeft: null,
      intervalId: null
    };
  },

  computed: {
    minutes: function minutes() {
      return Math.floor(this.timeLeft / 60).toString().padStart(2, '0');
    },
    seconds: function seconds() {
      return (this.timeLeft % 60).toString().padStart(2, '0');
    }
  },
  methods: {
    restart: function restart() {
      this.lines = [];
      this.edges = null;
      this.finishedGame = false;
      this.clearPoints();
      this.generatePoints();
      this.triangulate();
      this.arrangePoints();
      this.connectPoints();
      this.drawAllNodes();
    },
    matchPoints: function matchPoints(checkPoint, mousePoint) {
      if (mousePoint.x > checkPoint.x + this.pointSize) {
        return false;
      }

      if (mousePoint.x < checkPoint.x - this.pointSize) {
        return false;
      }

      if (mousePoint.y > checkPoint.y + this.pointSize) {
        return false;
      }

      if (mousePoint.y < checkPoint.y - this.pointSize) {
        return false;
      }
      return true;
    },
    clear: function clear() {
      this.context.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    },
    clearPoints: function clearPoints() {
      this.points = [];
      this.clear();
    },
    getMousePos: function getMousePos(evt) {
      var rect = this.context.canvas.getBoundingClientRect();
      return {
        x: parseInt((evt.clientX - rect.left) / (rect.right - rect.left) * this.canvasWidth),
        y: parseInt((evt.clientY - rect.top) / (rect.bottom - rect.top) * this.canvasHeight)
      };
    },
    mouseup: function mouseup(event) {
      var _this2 = this;

      var mouseUpPoint = this.getMousePos(event);
      if (this.dragMode && this.overPoint) {
        this.dragPoint(this.overPoint, mouseUpPoint);
        this.dragMode = false;
        this.points.forEach(function (point) {
          _this2.drawCircle(point, _this2.pointSize);
        });
        if (this.intersectedCount === 0 && !this.finishedGame) {
          this.playWin();
        }
      } else {
        this.connectedWithOverPoint = null;
      }
    },
    dragPoint: function dragPoint(selectedPoint, newPoint) {
      var _this3 = this;

      if (this.finishedGame || this.timeLeft === 0) {
        return;
      }
      this.points.map(function (pointToMove) {
        if (pointToMove.x === selectedPoint.x && pointToMove.y === selectedPoint.y) {
          pointToMove.x = newPoint.x;
          pointToMove.y = newPoint.y;

          _this3.clear();
          _this3.drawAllNodes();
        }
      });
    },
    mousemove: function mousemove(event) {
      var point = this.getMousePos(event);

      if (this.dragMode && this.overPoint) {
        this.dragPoint(this.overPoint, point);
      }
    },
    mousedown: function mousedown(event) {
      var point = this.getMousePos(event);
      if (this.isMouseOnNode(point)) {
        this.findConnectedWithOverPoint();

        this.dragMode = true;
      } else {
        this.dragMode = false;
      }
    },
    isMouseOnNode: function isMouseOnNode(point) {
      return this.selectedPoint(point) !== null;
    },
    selectedPoint: function selectedPoint(point) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.points), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var iteratedPoint = _step.value;

          if (this.matchPoints(iteratedPoint, point)) {
            this.overPoint = iteratedPoint;
            return iteratedPoint;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.overPoint = null;
      return null;
    },
    addNode: function addNode(point) {
      this.context.save();
      this.drawNode(point);
      this.context.restore();
      this.points.push(point);
    },
    isIntersect: function isIntersect(line1, line2) {
      var a1 = line1.endPoint.y - line1.startPoint.y;
      var b1 = line1.startPoint.x - line1.endPoint.x;
      var c1 = a1 * line1.startPoint.x + b1 * line1.startPoint.y;

      var a2 = line2.endPoint.y - line2.startPoint.y;
      var b2 = line2.startPoint.x - line2.endPoint.x;
      var c2 = a2 * line2.startPoint.x + b2 * line2.startPoint.y;

      var d = a1 * b2 - a2 * b1;

      if (d === 0) {
        return false;
      }

      var x = (b2 * c1 - b1 * c2) / d;
      var y = (a1 * c2 - a2 * c1) / d;

      if ((this.isInBetween(line1.startPoint.x, x, line1.endPoint.x) || this.isInBetween(line1.startPoint.y, y, line1.endPoint.y)) && (this.isInBetween(line2.startPoint.x, x, line2.endPoint.x) || this.isInBetween(line2.startPoint.y, y, line2.endPoint.y))) {
        return true;
      }

      return false;
    },
    isInBetween: function isInBetween(a, b, c) {
      if (Math.abs(a - b) < 0.000001 || Math.abs(b - c) < 0.000001) {
        return false;
      }

      return a < b && b < c || c < b && b < a;
    },
    drawNode: function drawNode(point) {
      this.context.beginPath();
      this.context.moveTo(point.x - this.pointSize, point.y - this.pointSize);
      this.context.lineTo(point.x - this.pointSize, point.y + this.pointSize);
      this.context.lineTo(point.x + this.pointSize, point.y + this.pointSize);
      this.context.lineTo(point.x + this.pointSize, point.y - this.pointSize);
      this.context.lineTo(point.x - this.pointSize, point.y - this.pointSize);
      this.context.fillStyle = this.fillStyle;
      this.context.fill();
      this.context.strokeStyle = this.strokeStyle;
      this.context.stroke();
    },
    findConnectedWithOverPoint: function findConnectedWithOverPoint() {
      var _this4 = this;

      if (this.connectedWithOverPoint && this.connectedWithOverPoint.overPoint === this.overPoint) {
        return;
      }
      var connectedWithOverPoint = [];
      this.lines.forEach(function (_ref) {
        var startPoint = _ref.startPoint,
            endPoint = _ref.endPoint,
            isIntersected = _ref.isIntersected;

        if (startPoint === _this4.overPoint) {
          connectedWithOverPoint.push(endPoint);
        } else if (endPoint === _this4.overPoint) {
          connectedWithOverPoint.push(startPoint);
        }
      });
      this.connectedWithOverPoint = { overPoint: this.overPoint, connectedPoints: connectedWithOverPoint };
    },
    isPointConnectWithOverPoint: function isPointConnectWithOverPoint(point) {
      if (this.overPoint === point) {
        return true;
      }
      if (!this.connectedWithOverPoint) {
        return false;
      }
      if (this.connectedWithOverPoint.connectedPoints && this.connectedWithOverPoint.connectedPoints.includes(point)) {
        return true;
      }
    },
    drawCircle: function drawCircle(point, radius) {
      this.context.fillStyle = this.isPointConnectWithOverPoint(point) && this.dragMode ? '#DA0' : '#d46';
      this.context.beginPath();
      this.context.arc(point.x, point.y, radius, 0, Math.PI * 2, true);
      this.context.closePath();
      this.context.fill();
    },
    Line: function Line(startPoint, endPoint, isIntersected) {
      return {
        startPoint: startPoint,
        endPoint: endPoint,
        isIntersected: isIntersected
      };
    },
    drawLine: function drawLine(x1, y1, x2, y2, isIntersected) {
      this.context.beginPath();
      this.context.moveTo(x1, y1);
      this.context.lineTo(x2, y2);
      this.context.lineWidth = 2;
      this.context.strokeStyle = isIntersected ? 'navy' : '#43e3bc';
      this.context.stroke();
    },
    generatePoints: function generatePoints() {
      for (var i = 0; i < this.pointsCount; i++) {
        var x = 30 + Math.floor(Math.random() * (this.canvasWidth - 60));
        var y = 30 + Math.floor(Math.random() * (this.canvasHeight - 60));
        this.points.push(new __WEBPACK_IMPORTED_MODULE_5__Point_js__["a" /* default */](x, y));
      }
    },
    arrangePoints: function arrangePoints() {
      for (var i = 0; i < this.pointsCount - 4; i++) {
        var x = Math.floor(this.canvasWidth / 2 + 150 * Math.cos(2 * Math.PI * i / (this.pointsCount - 4)));
        var y = Math.floor(this.canvasHeight / 2 + 150 * Math.sin(2 * Math.PI * i / (this.pointsCount - 4)));
        this.points[i] = new __WEBPACK_IMPORTED_MODULE_5__Point_js__["a" /* default */](x, y);
      }
      for (var _i = 0; _i < 4; _i++) {
        var _x = Math.floor(this.canvasWidth / 2 + 70 * Math.cos(2 * Math.PI * _i / 4));
        var _y = Math.floor(this.canvasHeight / 2 + 70 * Math.sin(2 * Math.PI * _i / 4));
        this.points[this.pointsCount - _i - 1] = new __WEBPACK_IMPORTED_MODULE_5__Point_js__["a" /* default */](_x, _y);
      }
    },
    connectPoints: function connectPoints() {
      var _this5 = this;

      this.lines = [];
      this.edges.forEach(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            a = _ref3[0],
            b = _ref3[1];

        _this5.lines.push(_this5.Line(_this5.points[a], _this5.points[b], false));
      });
    },
    triangulate: function triangulate() {
      this.lines = [];
      var coordinates = this.points.map(function (_ref4) {
        var x = _ref4.x,
            y = _ref4.y;
        return [x, y];
      });
      var triangles = __WEBPACK_IMPORTED_MODULE_6_cdt2d___default()(coordinates, this.edges || [], { exterior: true });
      var edges = [];
      triangles.forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 3),
            a = _ref6[0],
            b = _ref6[1],
            c = _ref6[2];

        edges.push([a, b]);
        edges.push([b, c]);
        edges.push([c, a]);
      });
      if (!this.edges) {
        this.edges = edges;
      }
    },
    playWin: function playWin() {
      this.finishedGame = true;
    },
    updateLineIntersection: function updateLineIntersection() {

      this.intersectedCount = 0;
      for (var i = 0; i < this.lines.length; i++) {
        var line1 = this.lines[i];
        line1.isIntersected = false;

        for (var j = 0; j < i; j++) {
          var line2 = this.lines[j];

          if (this.isIntersect(line1, line2)) {
            this.intersectedCount = this.intersectedCount + 1;
            line1.isIntersected = true;
            line2.isIntersected = true;
            this.lines[i] = line1;
            this.lines[j] = line2;
          }
        }
      }
    },
    drawAllLines: function drawAllLines() {
      var _this6 = this;

      this.updateLineIntersection();
      this.lines.forEach(function (_ref7) {
        var startPoint = _ref7.startPoint,
            endPoint = _ref7.endPoint,
            isIntersected = _ref7.isIntersected;

        _this6.drawLine(startPoint.x, startPoint.y, endPoint.x, endPoint.y, isIntersected);
      });
    },
    drawAllNodes: function drawAllNodes() {
      this.context.save();
      this.connectPoints();
      this.drawAllLines();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.points), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var point = _step2.value;

          this.drawCircle(point, this.pointSize);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.context.restore();
    },
    startTimer: function startTimer() {
      var _this7 = this;

      this.intervalId = setInterval(function () {
        if (_this7.timeLeft > 0) {
          _this7.timeLeft--;
        } else {
          clearInterval(_this7.intervalId);
        }
      }, 1000);
    }
  }
});

/***/ })

},[45]);


// WEBPACK FOOTER //
// static/js/app.492c4393596e3ef8cb93.js